import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  searchSession: {
    maxWidth: '90%',
    margin: '0 auto',
    width: '700px',
  },
  searchDiv: {
    //borderRadius: 4,
    width: '90%',
    margin: '5rem 0 2rem 0',
    display: 'flex',
    paddingLeft: '30px',
    background: 'rgba(255, 255, 255, 0.7)',
    border: "1px solid #D9DCDF",
    //boxSizing: 'border-box',
    borderRadius: '90.5px',
    height: '50px',
  },
  searchIcon: {
    maxHeight: "30px"
  },
  searchBar: {

  },
  pagination: {
    borderRadius: 4,
    //marginTop: '1rem',
    padding: '16px',
  },
  gridContainer: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
    },
    padding: 0,
  },
  tagListGrid: {
    width: "80%"
  },
  tagChip: {
    fontSize: "16px",
    margin: "10px",
    color: "#ADADAD",
    //backgroundColor: "rgb(217, 220, 223,0.4)",
    background: 'rgba(217, 220, 223, 0.4)',
    border: "1px solid #FFFFFF",
    //box-sizing: border-box;
    borderRadius: "25px",
    height: '36px',
    // opacity:"0.4"
    "&:hover": {

      // textDecoration: 'none',
      // color: "#000000",
      opacity: 0.7
    }
  },
  tagChipClicked: {
    fontSize: "16px",
    margin: "10px",
    color: "white",
    //backgroundColor: "rgb(217, 220, 223,0.4)",
    // background: 'rgba(217, 220, 223, 0.4)',
    background: '#F3923D',
    border: "1px solid #FFFFFF",
    //box-sizing: border-box;
    borderRadius: "25px",
    height: '36px',
    // opacity:"0.4"
    "&:hover": {

      // textDecoration: 'none',
      // color: "#000000",
      opacity: 0.7
    }
  },
  projectsGrid: {
    margin: "5rem 0 2rem 0",
  },
  pageNumberSection:{
    margin: 'auto',
  },
}));